// Overlay global affiché pendant les requêtes qui modifient des données (POST/PUT/PATCH/DELETE).
// Bloque physiquement les clics (double-clic inclus) tant qu'une requête est en cours.
let overlayEl = null;
let styleInjected = false;
let pendingCount = 0;

function ensureOverlay() {
  if (overlayEl) return overlayEl;

  if (!styleInjected) {
    const style = document.createElement("style");
    style.textContent = `
      #global-request-overlay {
        position: fixed;
        inset: 0;
        background: rgba(255, 255, 255, 0.35);
        z-index: 2147483647;
        display: none;
        align-items: center;
        justify-content: center;
        cursor: wait;
      }
      #global-request-overlay .grl-spinner {
        width: 48px;
        height: 48px;
        border: 5px solid rgba(0, 123, 255, 0.25);
        border-top-color: #007bff;
        border-radius: 50%;
        animation: grl-spin 0.7s linear infinite;
      }
      @keyframes grl-spin {
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
    styleInjected = true;
  }

  overlayEl = document.createElement("div");
  overlayEl.id = "global-request-overlay";
  overlayEl.innerHTML = '<div class="grl-spinner"></div>';
  document.body.appendChild(overlayEl);
  return overlayEl;
}

export function beginRequest() {
  pendingCount += 1;
  ensureOverlay().style.display = "flex";
}

export function endRequest() {
  pendingCount = Math.max(0, pendingCount - 1);
  if (pendingCount === 0 && overlayEl) {
    overlayEl.style.display = "none";
  }
}
